<script lang="ts" setup>
import BsNavDropdownItem from '@/legacy/components/NavDropdownItem.vue'
import { createGAEvent, GaGeneralEvent } from '@/assets/ts/customEvent'
import { getCurrentGaPageName } from '@/lib/utils'

const props = defineProps({
	list: {
		type: Object,
		required: true,
	},
	link: {
		type: String,
		default: '',
	},
	isAlignRight: {
		type: Boolean,
		default: false,
	},
	isSurfaceTextSmall: {
		type: Boolean,
		default: false,
	},
	isHide: {
		type: Boolean,
		default: false,
	},
	newBadgeText: {
		type: String,
		default: 'New',
	},
})

function handleSingleLinkClick() {
	const pageName = getCurrentGaPageName()
	createGAEvent(GaGeneralEvent.ButtonClick, {
		page_name: pageName,
		button_name: props.list.name || '',
	})
}
</script>

<template>
	<div
		v-show="!isHide"
		:class="[
			'bs-nav-dropdown',
			{
				'pure-link': list.link,
				'align-right': isAlignRight,
			},
		]"
	>
		<div
			:class="[
				'bs-nav-dropdown__surface',
				{
					small: isSurfaceTextSmall,
				},
			]"
		>
			<template v-if="list.link">
				<a
					:href="list.link"
					class="bs-nav-dropdown__surface__link"
					@click="handleSingleLinkClick"
				>
					{{ list.name }}
				</a>
			</template>
			<template v-else>
				<div class="bs-nav-dropdown__surface__text">{{ list.name }}</div>
				<i class="bs-icon-arrow-down-new"></i>
			</template>
		</div>
		<div class="bs-nav-dropdown__bottom" v-if="!link">
			<BsNavDropdownItem
				v-for="subMenu in list.children"
				:key="subMenu.name"
				:link="subMenu.link"
				:icon="subMenu.icon"
				:name="subMenu.name"
				:desc="subMenu.desc"
				:isNewBadge="subMenu.isNewBadge"
				:newBadgeText="newBadgeText"
				:parentName="list.name"
			></BsNavDropdownItem>
		</div>
	</div>
</template>
